var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Gang2WayLightSwitch01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st2{font-family:'MyriadPro-Regular';}\n\t.st3{font-size:8.3094px;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 3.9,
    cy: 7.9,
    r: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 5.2,
    y1: 7.9,
    x2: 13.5,
    y2: 7.9
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 7.6442 10.4391)",
    className: "st2 st3"
  }, "2"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Gang2WayLightSwitch01);
export default __webpack_public_path__ + "static/media/1Gang2WayLightSwitch-01.18c2e0f3189fcddf63a29b99987aeec4.svg";
export { ForwardRef as ReactComponent };